// extracted by mini-css-extract-plugin
export var hideEditor = "_mf-2";
export var infoIcon = "_mf-3";
export var label = "_mf-1";
export var labelContainer = "_mf-0";
export var readonlyText = "_mf-4";